import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { LoggedGuard } from './guards/logged.guard';
import { GuestAuthResolver } from './resolvers/guest-auth.resolver.js';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
    canActivate: [AuthGuard],
  },
  {
    path: 'guest-auth',
    resolve: { guestAuth: GuestAuthResolver },
    loadComponent: () => import('./guest-auth/guest-auth.page').then((m) => m.GuestAuthPage),
  },
  {
    path: 'chat/:agentId',
    loadComponent: () => import('./chat/chat.page').then( m => m.ChatPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'chatBo/:agentId',
    loadComponent: () => import('./chatBo/chatBo.page').then( m => m.ChatBoPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then( m => m.LoginPage),
  },
  {
    path: 'register',
    loadComponent: () => import('./register/register.page').then( m => m.RegisterPage),
  },
  {
    path: 'auth',
    loadComponent: () => import('./auth/auth.page').then( m => m.AuthPage),
    canActivate: [LoggedGuard],
  },
  {
    path: 'logout',
    loadComponent: () => import('./logout/logout.page').then( m => m.LogoutPage),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  }
];
